__webpack_require__.p = "/schoolio/";